import * as fromDatatype from "../../../../models/datatype-library";
export class SvcIssueProcessStatusDto {
    process_status_column_name: fromDatatype.VarcharDatatypeInterface;
    process_status_column_guid: fromDatatype.GuidDataFieldInterface;
  }
